import React, { createContext, useState, useContext } from 'react';
import ContestLoader from './ContestLoader';
const LoaderContext = createContext();
export const useLoader = () => {
    const context = useContext(LoaderContext);
    if (!context) {
        throw new Error("useLoader must be used within a LoaderProvider");
    }
    return context;
};

export const LoaderProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showLoader = () => setIsLoading(true);
    const hideLoader = () => setIsLoading(false);

    return (
        <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
            {isLoading && <ContestLoader />}
            {children}
        </LoaderContext.Provider>
    );
};
